import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Table, Container, Row, Col, Form, } from 'react-bootstrap';
import $ from 'jquery';
import Loginheader from '../Loginheader';
import Menu from '../Menu';
import * as Common from '../Common';
import Dialog from '../Dialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

function Ad2Modification() {
    const navigate = useNavigate();
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [tranListData, setTranListData] = useState([]);
    const [srchBran, setSrchBran] = useState("0");
    const [ddSrchBranOptions, setDdSrchBranOptions] = useState([]);
    const [srchBranSelect, setSrchBranSelect] = useState([]);
    const [srno, setSrno] = useState("");
    const [modificationtype, setModificationtype] = useState("");
    const [settleServiceCharge, setSettleServiceCharge] = useState("");
    const [ad2RefNo, setAd2RefNo] = useState("");
    const [idfc4, setIdfc4] = useState("");
    const [showEditRow, setShowEditRow] = useState(false);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'AD2MODIFICATION'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    Common.callApi(Common.apiUser, [sid, 'branchallowedselect'], function (result) {
                        let resp2 = JSON.parse(result);
                        setDdSrchBranOptions(resp2);
                        if (resp2.length === 2) {
                            setSrchBranSelect(resp2[1]);
                            setSrchBran(resp2[1].value);
                            console.log(resp2);
                        }
                    });
                    //get list of requests
                } else {
                    // navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    function handleSrchBranchOptions(v) {
        setSrchBranSelect(v);
        setSrchBran(v.value);
    }
    function listHandler() {
        var msg = [], i = 0;
        msg[i++] = Common.getMessage("MSG0006");
        (srno === "" || srno === 0) && (msg[i++] = "Srno");
        modificationtype === "" && (msg[i++] = "Modification Type");
        if (i > 1) {
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
            return;
        } else {
            let obj = {
                srno: srno
            }
            Common.callApi(Common.apiAD2Modification, [sid, 'list', JSON.stringify(obj)], function (result) {
                let resp = JSON.parse(result);
                if (resp.status) {
                    setTranListData(resp.data);
                    setShowEditRow(false);
                    setSettleServiceCharge(0)
                    setAd2RefNo('')
                } else {
                    setMsgText(resp.msg);
                    setMsgBox(true);
                }
            });
        }
    }

    function handleEditRequest() {
        setShowEditRow(true);
    }
    function saveHandler() {
        let msg = [], i = 0;
        msg[i++] = Common.getMessage("MSG0006");
        modificationtype === 'BANKCHANRGE' && settleServiceCharge === "" && (msg[i++] = "Bank Charges");
        modificationtype === 'AD2REFNUM' && ad2RefNo === "" && (msg[i++] = "AD2 Ref No");
        modificationtype === 'IDFCNOSTRO' && idfc4 === "" && (msg[i++] = "IDFC Nostro Charges");

        if (i > 1) {
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
            return;
        } else {
            let obj = {
                srno: srno,
                modificationtype: modificationtype,
                settleServiceCharge: settleServiceCharge,
                ad2RefNo: ad2RefNo,
                idfc4: idfc4,
                erpLocation: tranListData[0].req_erp_location,
                erpSrno: tranListData[0].req_erp_srno
            }
            Common.callApi(Common.apiAD2Modification, [sid, 'save', JSON.stringify(obj)], function (result) {
                let resp = JSON.parse(result);
                if (resp.status) {
                    setMsgText(resp.msg);
                    setMsgBox(true);
                    setTranListData(resp.data);
                    setShowEditRow(false);
                } else {
                    setMsgText(resp.msg);
                    setMsgBox(true);
                }
            });
        }
    }
    return (
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
            <Container fluid >
                <>
                    <Row>
                        <Col>
                            <h1>AD2 Modification</h1>
                        </Col>
                    </Row>
                    <Row>
                        {/* <Col>
                                <Form.Group>
                                    <Form.Label>Branch</Form.Label>
                                    <Select
                                        value={srchBranSelect}
                                        onChange={handleSrchBranchOptions}
                                        options={ddSrchBranOptions}
                                        isDisabled={ddSrchBranOptions.length === 2}
                                    />
                                </Form.Group>
                            </Col> */}

                        <Col className="col-md-3 col-6">
                            <Form.Group>
                                <Form.Label>Srno<span className="handCursor colorThemeBlue">
                                </span></Form.Label>
                                <Form.Control type="text" placeholder="Srno...."
                                    maxLength={50} autoComplete="off"
                                    value={srno}
                                    onChange={(e) => setSrno(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col className="col-md-3 col-6">
                            <Form.Label>Modification Type</Form.Label>
                            <Form.Select
                                value={modificationtype}
                                onChange={(e) => { setModificationtype(e.target.value) }}>
                                <option value="">Select</option>
                                <option value="BANKCHANRGE">Bank Charges</option>
                                <option value="AD2REFNUM">Ad2 Ref No</option>
                                <option value="IDFCNOSTRO">IDFC Nostro</option>
                            </Form.Select>
                        </Col>
                    </Row>
                    &nbsp;
                    <Row>
                        <Col>
                            <Button id="btnSearchRequest" variant="outline-primary" size="sm" onClick={() => listHandler(1)}>List</Button>&nbsp;
                            {/* <Button variant="outline-danger" size="sm" onClick={() => resetSearch()}>Reset</Button>&nbsp; */}
                        </Col>
                    </Row>
                    &nbsp;
                    <Row>
                        <Col>
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <td>Action</td>
                                        <td>SrNo.</td>
                                        <td>Ref No</td>
                                        <td>Ad2 no</td>
                                        <td>ISD</td>
                                        <td>Quantity</td>
                                        <td>Bank Charges</td>
                                        <td>Nostro Charges</td>
                                        {/* <td>FX Module Settle Charges</td> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {tranListData.map((res) =>
                                        <>
                                            <tr key={res.req_srno} className={res.req_status === "0" ? 'bg-danger text-white' : ''}>
                                                <td>
                                                    {res.req_status === "1" &&
                                                        <span onClick={handleEditRequest} className='handCursor colorThemeBlue'>
                                                            <FontAwesomeIcon icon={faEdit} />
                                                        </span>
                                                    }
                                                </td>
                                                <td >{res.req_srno}</td>
                                                <td >{res.req_refno}</td>
                                                <td >{res.req_ad2ref}</td>
                                                <td >{res.req_isd}</td>
                                                <td >{res.req_quantity}</td>
                                                <td>{res.req_settle_service_charges}</td>
                                                <td>{res.req_settle_service_charges_idfc4}</td>
                                            </tr>
                                            {showEditRow &&
                                                <tr>
                                                    <td colSpan={7}>
                                                        <div className="row align-items-center">
                                                            {modificationtype === 'AD2REFNUM' && res.req_status === "1" && (
                                                                <div className="col-md-9 d-flex align-items-center gap-2">
                                                                    <Form.Label className="mb-0">
                                                                        Ad2 Ref No :
                                                                    </Form.Label>
                                                                    <Form.Control type="text" placeholder="Ad2 Ref No ...." maxLength={20}
                                                                        value={ad2RefNo} onChange={(e) => setAd2RefNo(e.target.value)}
                                                                    />
                                                                </div>
                                                            )}
                                                            {modificationtype === 'BANKCHANRGE' && res.req_status === "1" && (
                                                                <div className="col-md-9 d-flex align-items-center gap-2">
                                                                    <Form.Label className="mb-0">
                                                                        Bank Charges :
                                                                    </Form.Label>
                                                                    <Form.Control type="number" placeholder="Bank Charges...." maxLength={6}
                                                                        value={settleServiceCharge} onChange={(e) => setSettleServiceCharge(e.target.value)}
                                                                    />
                                                                </div>
                                                            )}
                                                            {modificationtype === 'IDFCNOSTRO' && res.req_status === "1" && (
                                                                <div className="col-md-9 d-flex align-items-center gap-2">
                                                                    <Form.Label className="mb-0">
                                                                        IDFC Nostro Charges :
                                                                    </Form.Label>
                                                                    <Form.Control type="number" placeholder="IDFC Nostro Charges...." maxLength={6}
                                                                        value={idfc4} onChange={(e) => setIdfc4(e.target.value)}
                                                                    />
                                                                </div>
                                                            )}
                                                            <div className="col-md-3 text-end">
                                                                <Button variant="outline-primary" size="sm" onClick={() => saveHandler(1)} >
                                                                    Save
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            }
                                        </>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </>
            </Container >
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
        </>
    );
}
export default Ad2Modification;